import { RouteObject, Outlet } from "react-router-dom";
import { Matches } from "src/constants/matches";
import ItemsSelectionProvider from "src/context/ItemsSelectionProvider";
import MasonryLayoutProvider from "src/context/MasonryLayoutProvider";
import MessagingProvider from "src/context/MessagesProvider";
import OrdersModalProvider from "src/context/OrdersModalProvider";
import PatientProvider from "src/context/PatientProvider";
import TasksProvider from "src/context/TasksProvider";
import UpdateBannerProvider from "src/context/UpdateBannerProvider";
import ViewIntakeProvider from "src/context/ViewIntakeProvider/ViewIntakeProvider";
import WaitingRoomProvider from "src/context/WaitingRoomProvider";
import DefaultNavLayout from "src/layouts/DefaultNavLayout";
import PatientLayout from "src/layouts/PatientLayout";
import Cancellations from "src/pages/Cancellations";
import Coupons from "src/pages/Coupons";
import FitnessAndNutrition from "src/pages/FitnessAndNutrition";
import Invoices from "src/pages/Invoices";
import Medications from "src/pages/Medications";
import NonProviderTaskView from "src/pages/NonProviderTaskView";
import Orders from "src/pages/Orders";
import Patients from "src/pages/Patients";
import PromoBanners from "src/pages/PromoBanners";
import ProviderTaskQueue from "src/pages/ProviderTaskQueue";
import ProviderTaskView from "src/pages/ProviderTaskView";
import StateTracker from "src/pages/StateTracker/StateTracker";
import WaitingRoomTracker from "src/pages/WaitingRoomTracker";
import { organizationPaths } from "./organization";
import Messaging from "src/pages/NonProviderTaskView/components/Messaging";
import Home from "src/pages/Home";
import ClinicalNotes from "src/pages/ClinicalNotes";
import Disputes from "src/pages/Disputes";
import InvoiceModalProvider from "src/context/InvoiceModalProvider";
import TitrationsManagement from "src/pages/TitrationsManagement";
import TitrationDetails from "src/pages/TitrationDetails";
import { titrationsLoader } from "src/loaders/titrationsLoader";
import { medicationTitrationsLoader } from "src/loaders/medicationTitrationsLoader";
import MyAccount from "src/components/MyAccount";
import MedicationsDrawerProvider from "src/context/drawers/MedicationsDrawerProvider";
import VidaLayout from "src/layouts/VidaLayout";
import VidaRoute from "src/pages/VidaRoute";

export const dashboardPath: RouteObject[] = [
  {
    element: <DefaultNavLayout />,
    children: [
      {
        path: "dashboard",
        children: [
          {
            element: (
              <ItemsSelectionProvider>
                <OrdersModalProvider>
                  <Orders />
                </OrdersModalProvider>
              </ItemsSelectionProvider>
            ),
            path: "orders",
          },
          {
            element: <Home />,
            index: true,
          },
          ...organizationPaths,
          {
            path: "chats",
            element: <VidaLayout />,
            children: [{ index: true, element: <VidaRoute /> }],
          },
          {
            path: "state-tracker",
            element: <StateTracker />,
          },
          {
            path: "patients",
            element: <Patients />,
          },
          {
            path: "medications",
            element: (
              <MedicationsDrawerProvider>
                <Medications />
              </MedicationsDrawerProvider>
            ),
          },
          {
            path: "titrations-management",
            children: [
              {
                index: true,
                element: <TitrationsManagement />,
                loader: titrationsLoader,
              },
              {
                path: Matches.TITRATION_ID,
                element: <TitrationDetails />,
                loader: medicationTitrationsLoader,
              },
            ],
          },
          {
            path: "waiting-room-tracker",
            element: (
              <ItemsSelectionProvider>
                <WaitingRoomTracker />
              </ItemsSelectionProvider>
            ),
          },
          {
            path: `patients/${Matches.PATIENT_ID}`,
            element: (
              <PatientProvider>
                <MasonryLayoutProvider>
                  <PatientLayout />
                </MasonryLayoutProvider>
              </PatientProvider>
            ),
            children: [
              {
                index: true,
                element: <NonProviderTaskView />,
              },
              {
                path: `messages/${Matches.THREAD_ID}`,
                element: (
                  <MessagingProvider>
                    <Messaging />
                  </MessagingProvider>
                ),
              },
              {
                path: "invoices",
                element: (
                  <InvoiceModalProvider>
                    <Invoices />
                  </InvoiceModalProvider>
                ),
              },
              {
                path: "disputes",
                element: <Disputes />,
              },
              {
                path: `notes/${Matches.NOTE_TYPE}`,
                element: <ClinicalNotes />,
              },
            ],
          },
          {
            path: "resources",
            children: [
              {
                path: Matches.RESOURCE_TYPE,
                element: <h1>Resources</h1>,
              },
            ],
          },
          {
            path: "queue",
            children: [
              {
                path: Matches.QUEUE_TYPE,
                element: (
                  <MasonryLayoutProvider>
                    <TasksProvider>
                      <Outlet />
                    </TasksProvider>
                  </MasonryLayoutProvider>
                ),
                children: [
                  {
                    index: true,
                    element: <ProviderTaskQueue />,
                  },
                  {
                    path: "no-tasks",
                    element: <h2>No Tasks</h2>,
                  },
                  {
                    path: Matches.WAIT_ROOM_ID,
                    element: (
                      <WaitingRoomProvider>
                        <ItemsSelectionProvider>
                          <ProviderTaskView />
                        </ItemsSelectionProvider>
                      </WaitingRoomProvider>
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: "fitness-nutrition-plans",
            element: <FitnessAndNutrition />,
          },
          {
            path: "promo-banners",
            element: (
              <UpdateBannerProvider>
                <PromoBanners />
              </UpdateBannerProvider>
            ),
          },
          { path: "coupons", element: <Coupons /> },
          {
            path: "cancellations",
            element: (
              <ViewIntakeProvider>
                <Cancellations />
              </ViewIntakeProvider>
            ),
          },
        ],
      },
      {
        path: "me",
        element: <MyAccount />,
      },
    ],
  },
];
